import { Card } from "@mui/material";
import { EditorFormWithMutation } from "../../../../pages/keys/KeyBrowser";

import { useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAccountContext } from "../../../../strict/app/AccountResolver";
import { BreadcrumbsInformation, KeyPageHeader } from "../../components/KeyPageHeader";
import { KeyPageWrapper } from "../../components/KeyPageWrapper";

const AddKey = () => {
  const { urlName: url_name } = useAccountContext();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const onCompletedCreateCredential = useCallback(
    (credentialName: string) => {
      toast.success(`${credentialName} was successfully created!`);

      navigate(`/app/${url_name}/keys`);
    },
    [navigate, url_name]
  );

  useEffect(() => {
    const handleOauthSuccess = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data.message === "oauthSuccess") {
        onCompletedCreateCredential(event.data.credential_name);
      }
    };

    window.addEventListener("message", handleOauthSuccess);

    return () => {
      window.removeEventListener("message", handleOauthSuccess);
    };
  }, [onCompletedCreateCredential]);

  const keyType = searchParams.get("keyType");

  const keysUrl = `/app/${url_name}/keys`;

  const breadcrumbs: BreadcrumbsInformation[] = [
    {
      name: "Vault",
      link: keysUrl,
      "data-testid": "vault-breadcrumb",
    },
    {
      name: "Add key",
    },
  ];

  if (!keyType) {
    navigate(keysUrl);
    return;
  }

  const onCompletedEditCredential = (credential: { name?: string; oauth_url?: string; exist?: boolean }) => {
    if (credential.oauth_url) {
      window.open(credential.oauth_url, "oauthpop", "width=800, height=600");
    } else if (credential.name) {
      onCompletedCreateCredential(credential.name);
    }
  };

  return (
    <KeyPageWrapper>
      <KeyPageHeader keyType={keyType} breadcrumbsInformation={breadcrumbs} />
      <Card sx={{ padding: 4 }}>
        <EditorFormWithMutation onCompleted={onCompletedEditCredential} mode={"add"} keyType={keyType} />
      </Card>
    </KeyPageWrapper>
  );
};

export { AddKey };
